import { Col, WithColorProps } from "@commonlibs";
import styled, { css } from "styled-components";

export const LoadingPageWrapper = styled(Col)<WithColorProps>(
    ({ color }) => css`
        height: 100%;
        background-color: ${color};
        width: 100%;
        flex: 1;
        align-items: center;
        justify-content: center;
        .logo svg {
            width: 50vw;
            max-width: 16rem;
            height: auto;
        }
    `,
);
